import axios from 'axios'
import { returnData, config, catchError } from './api-utils'

const getContents = ({ type, targetId }) =>
  axios
    .get(`/content/${type}/${targetId}`, config())
    .then(returnData)
    .catch(catchError)

const createContent = ({ data, type, targetId, dimensionValueIds }) =>
  axios
    .post('/content', { data, type, targetId, dimensionValueIds }, config())
    .then(returnData)
    .catch(catchError)

const updateContent = ({ id, data }) =>
  axios
    .put(`/content/${id}`, { content: data }, config())
    .then(returnData)
    .catch(catchError)

const updateBudgetContent = ({ id, data, companyCode }) =>
  axios
    .put(`/${companyCode}/content/budget/${id}`, { content: data }, config())
    .then(returnData)
    .catch(catchError)

const updateSubBudgetContent = ({ id, data, companyCode }) =>
  axios
    .put(`/${companyCode}/content/subbudget/${id}`, { content: data }, config())
    .then(returnData)
    .catch(catchError)

const deleteBudgetContent = ({ id, companyCode }) =>
  axios
    .delete(`/${companyCode}/content/budget/${id}`, config())
    .then(returnData)
    .catch(catchError)

const deleteSubBudgetContent = ({ id, companyCode }) =>
  axios
    .delete(`/${companyCode}/content/subbudget/${id}`, config())
    .then(returnData)
    .catch(catchError)

const deleteContent = ({ id }) =>
  axios
    .delete(`/content/${id}`, config())
    .then(returnData)
    .catch(catchError)

const contentApi = {
  getContents,
  createContent,
  updateContent,
  updateBudgetContent,
  updateSubBudgetContent,
  deleteBudgetContent,
  deleteSubBudgetContent,
  deleteContent,
}

export default contentApi
